<template>
    <div>
        <v-layout row wrap>
            <v-flex lg3 sm6 xs12>
                <v-card class="ma-3" elevation="0" style="border: thin solid rgba(0,0,0,.12)">
                    <v-list-item>
                        <v-sheet class="mt-n12" color="green" width="50" height="50" elevation="1">
                            <v-icon dark large class="icondash">account_balance_wallet</v-icon>
                        </v-sheet>
                        <v-list-item-content>
                            <div class="text-right mb-2">Balance</div>
                            <v-list-item-title class="headline mb-1 text-right">{{formatAngka(wallet.balance)}}
                            </v-list-item-title>
                            <div>
                                <v-divider></v-divider>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-flex>
          <v-flex lg3 sm6 xs12>
            <v-card class="ma-3" elevation="0" style="border: thin solid rgba(0,0,0,.12)">
              <v-list-item>
                <v-sheet class="mt-n12" color="orange" width="50" height="50" elevation="1">
                  <v-icon dark large class="icondash">account_balance_wallet</v-icon>
                </v-sheet>
                <v-list-item-content>
                  <div class="text-right mb-2">Pending Balance</div>
                  <v-list-item-title class="headline mb-1 text-right">{{formatAngka(wallet.pendingBalance)}}
                  </v-list-item-title>
                  <div>
                    <v-divider></v-divider>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-card-actions>
              </v-card-actions>
            </v-card>
          </v-flex>
            <v-flex lg3 sm6 xs12>
                <v-card class="ma-3" elevation="0" style="border: thin solid rgba(0,0,0,.12)">
                    <v-list-item>
                        <v-sheet class="mt-n12" color="green" width="50" height="50" elevation="1">
                            <v-icon dark large class="icondash">send</v-icon>
                        </v-sheet>
                        <v-list-item-content>
                            <div class="text-right mb-2">Pending Cashout</div>
                            <v-list-item-title class="headline mb-1 text-right">{{formatAngka(wallet.pendingcashout)}}
                            </v-list-item-title>
                            <div>
                                <v-divider></v-divider>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>

        <v-tabs  v-model="tab">
            <v-tab>CashIn</v-tab>
            <v-tab>Pending CashIn</v-tab>
            <v-tab>CashOut</v-tab>
            <v-tab>History</v-tab>
            <v-tab>Bank</v-tab>

            <v-tab-item>
                <Cashin/>
            </v-tab-item>
          <v-tab-item>
            <Pending/>
          </v-tab-item>
            <v-tab-item>
                <Cashout/>
            </v-tab-item>
            <v-tab-item>
               <HistoryWallet/>
            </v-tab-item>
            <v-tab-item>
               <Banks/>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import Cashin from "@/components/wallets/Cashin";
    import Pending from "@/components/wallets/Pending";
    import Cashout from "@/components/wallets/Cashout";
    import HistoryWallet from "@/components/wallets/HistoryWallet";
    import Banks from "@/components/wallets/Banks";
    import {mapActions, mapState} from "vuex";
    import Utils from "@/plugins/utils";
    export default {
        name: "PageWallet",
        components: {Banks, HistoryWallet, Cashout, Cashin, Pending},
        data: ()=>({
            tab: null
        }),
        mounted(){
            this.getWallet()
        },
        computed: {
            ...mapState('Wallet',['wallet','loading'])
        },
        methods: {
            ...mapActions('Wallet',['getWallet']),
            formatAngka(val){
                return Utils.formatAngka(val)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .caro {
        height: 265px;
    }
    .icondash {
        margin-left: 6px;
        margin-top 5px;
    }
</style>
